export default {"src":"/_next/static/media/pin_dinner_green.2c5a4db0.svg","height":29,"width":21,"blurWidth":0,"blurHeight":0};